export default __webpack_public_path__ + "static/media/logo-red-trimmed.95aab793.png";